import { Box, Divider, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { PureLightThemeCaaS } from 'src/theme/schemes/PureLightTheme';
import { whatsNewData, WhatsNewEntry, WhatsNewEntryInput } from 'src/utils/helpMenuContent';
import {  formatWhatsNewDate } from 'src/utils/dateUtils';

//key for the whats new entry
const WHATS_NEW_DATES_STORAGE_KEY = 'rotogpt_whats_new_dates';

//function to get the key for the whats new entry
function getEntryKey(entry: WhatsNewEntryInput): string {
    return [entry.title, entry.description].filter(Boolean).join('\n');
}

//function to resolve the whats new entries and set the date and id
function resolveWhatsNewEntries(input: WhatsNewEntryInput[]): WhatsNewEntry[] {
    if (typeof window === 'undefined') {
        return input.map((e, i) => ({ id: i, title: e.title, description: e.description, date: e.date ?? formatWhatsNewDate(new Date()) }));
    }
    let stored: Record<string, string> = {};
    try {
        const raw = window.localStorage.getItem(WHATS_NEW_DATES_STORAGE_KEY);
        if (raw) stored = JSON.parse(raw);
    } catch {
        stored = {};
    }
    let updated = false;
    const resolved: WhatsNewEntry[] = input.map((entry, index) => {
        const key = getEntryKey(entry);
        let date = entry.date ?? stored[key];
        if (!date) {
            date = formatWhatsNewDate(new Date());
            stored[key] = date;
            updated = true;
        }
        return { id: index, title: entry.title, description: entry.description, date };
    });
    if (updated) {
        try {
            window.localStorage.setItem(WHATS_NEW_DATES_STORAGE_KEY, JSON.stringify(stored));
        } catch {
            // ignore
        }
    }
    return resolved.sort((a, b) => b.id - a.id);
}

interface WhatsNewProps {
    handleBack: () => void;
    handleClose: () => void;
}

const WhatsNew = ({ handleBack, handleClose }: WhatsNewProps) => {
    const sortedWhatsNew = useMemo(() => resolveWhatsNewEntries(whatsNewData), []);

    return (
        <Box
            sx={{
                flex: 1,
                overflowY: 'auto',
                minHeight: 0,
                p: 3,
                pt: 3,
                WebkitOverflowScrolling: 'touch',
                m: '0 auto',
                bgcolor: '#EDEDED',
            }}
        >
            {sortedWhatsNew.map((entry: WhatsNewEntry, index: number) => (
                <React.Fragment key={entry.id}>
                    <Box
                        sx={{
                            backgroundColor: 'transparent',
                            // px: 2,
                            py: 1,
                        }}
                    >
                        {/* {entry.title && (
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: PureLightThemeCaaS.colors.alpha.black[100],
                                    fontWeight: 900,
                                    pb: 0.5,
                                }}
                            >
                                {entry.title}
                            </Typography>
                        )} */}
                        <Typography
                            variant="h6"
                            sx={{
                                fontSize: "15px",
                                color: PureLightThemeCaaS.colors.alpha.black[100],
                                fontWeight: "semibold",

                            }}
                        >
                            {entry.description}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: PureLightThemeCaaS.colors.alpha.black[70],
                                display: 'block',
                                fontStyle: 'italic',
                                fontSize: "12px",
                                fontWeight: "medium",
                                // pt: 0.5,
                            }}
                        >
                            Updated {entry.date}
                        </Typography>
                    </Box>
                    <Divider sx={{ borderColor: PureLightThemeCaaS.colors.alpha.black[20] }} />
                    {/* )} */}
                </React.Fragment>
            ))}
        </Box>
    );
};

export default WhatsNew;